import Desktop from './Desktop';
import React from 'react';

export default function View(props) {
    return <Desktop {...props} />;
}